import { ComponentChild } from 'preact'
import classnames from 'classnames'
import Checkbox from '../../../control-components/ui-components/Checkbox'
import Phrase from '../../../libs/translationsUtils/phrase'
import { connectStateResults } from 'react-instantsearch-dom'
import { AllSearchResults } from '../../algolia/components'

export type sourcesWithExternalTypes =
  | 'community'
  | 'knowledge_base'
  | 'zendesk'
  | 'salesforce'
  | 'skilljar'
  | 'freshdesk'
  | 'federated'

export interface SourceTab {
  key: sourcesWithExternalTypes
  isEnabled: boolean
}

export type SourceTabsType = SourceTab[]

interface Props {
  title: ComponentChild
  updateSourceTabs: (tab: string, enabled: boolean) => void
  tabs: {[key: string]: boolean}
  allSearchResults: AllSearchResults|null
}

const labelMapping: Record<string, JSX.Element> = {
  community: <Phrase m='Forum' p='nav.title.community' />,
  knowledge_base: <Phrase m='Common' p='advanced.search.filter.knowledgebase.category' />,
  zendesk: <Phrase m='Forum' p='federated.search.zendesk' />,
  salesforce: <Phrase m='Forum' p='federated.search.salesforce' />,
  skilljar: <Phrase m='Forum' p='federated.search.skilljar' />,
  freshdesk: <Phrase m='Forum' p='federated.search.freshdesk' />,
  federated: <Phrase m='Forum' p='federated.search.federated' />
}

const SourceTabs = ({ tabs, updateSourceTabs, title, allSearchResults }: Props) => {
  const facets = Array.from(new Set(Object.keys(allSearchResults || {}).flatMap((index) => {
    if (!allSearchResults) return []
    const sourceFacet = allSearchResults[index]?.facets?.filter((f) => f.name === 'source')[0]
    return Object.keys(sourceFacet?.data || {})
  }))).sort()

  const updateTab = (tab: string) => updateSourceTabs(tab, !tabs[tab])
  return (
    <div className='instant-search__source-type-filter'>
      <span className='instant-search__filter-title'>{title}</span>
      <ul>
        {facets.map((source) => {
          return (
            <li
              key={source}
              className='instant-search__filter-list-item instant-search__source-filter-item'
            >
              <div
                className={classnames('instant-search-filter__label-wrapper', {
                  refined: tabs[source]
                })}
              >
                <Checkbox
                  label={labelMapping[source] || <Phrase m='Forum' p={`federated.search.${source}`} />}
                  onUpdate={() => updateTab(source)}
                  qaClasses='topic-type-checkbox'
                  checked={tabs[source]}
                />
              </div>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default connectStateResults(SourceTabs)
